import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OmniSharedUiModule } from '@cigna/omni/shared';
import { OmniConversationSummaryCardComponent } from './component/omni-conversation-summary-card.component';
import { OmniSummaryCardDatetimePipe } from './omni-summary-card-datetime.pipe';

@NgModule({
  imports: [CommonModule, OmniSharedUiModule],
  declarations: [
    OmniConversationSummaryCardComponent,
    OmniSummaryCardDatetimePipe,
  ],
  exports: [OmniConversationSummaryCardComponent],
})
export class OmniConversationSummaryCardModule {}
